import*as t from"react";let e=0;const n={...t}.useId;function u(u){if(void 0!==n){const t=n();return u??t}return function(n){const[u,r]=t.useState(n),o=n||u;return t.useEffect((()=>{null==u&&(e+=1,r(`mui-${e}`))}),[u]),o}(u)}export{u as default};
//# sourceMappingURL=useId.js.map
